module.exports = __webpack_public_path__ + "img/black-friday.e92ddc90.png";